import { createSelector } from 'reselect';

const selectEmailAccounts = (state: any) => state.emailAccounts;


export const selectEmailAccountsCurrentItem = createSelector([selectEmailAccounts], (emailAccounts) => emailAccounts.current);

export const selectEmailAccountsListItems = createSelector([selectEmailAccounts], (emailAccounts) => emailAccounts.list);

export const selectEmailAccountsItemById = (itemId: any) =>
    createSelector(selectEmailAccountsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEmailAccountsQueryItems = createSelector([selectEmailAccounts], (emailAccounts) => emailAccounts.query);

export const selectEmailAccountsCreatedItem = createSelector([selectEmailAccounts], (emailAccounts) => emailAccounts.create);

export const selectEmailAccountsUpdatedItem = createSelector([selectEmailAccounts], (emailAccounts) => emailAccounts.update);

export const selectEmailAccountsReadItem = createSelector([selectEmailAccounts], (emailAccounts) => emailAccounts.read);

export const selectEmailAccountsDeletedItem = createSelector([selectEmailAccounts], (emailAccounts) => emailAccounts.delete);

export const selectEmailAccountsSearchedItems = createSelector([selectEmailAccounts], (emailAccounts) => emailAccounts.search);

export const selectEmailAccountsItemsCount = createSelector([selectEmailAccounts], (emailAccounts) => emailAccounts.count);

export const selectEmailAccountsItemsFilter = createSelector([selectEmailAccounts], (emailAccounts) => emailAccounts.filter);